import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { sessionGetItemObj, sessionGetItemStr } from '../../../utils/sessionHelpers'
import AssetRequestManagementDetailWidgets from '../../../widgets/assetRequestManagementDetailWidgets/AssetRequestManagementDetailWidgets'
import { getAssetRequestManagementDetail } from '../../../redux/actions/assetRequestManagementDetail'

export default function AssetRequestManagementDetail() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const bookingInfo = sessionGetItemObj('bookingInfo')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const id = bookingInfo.id ? bookingInfo.id : ''
      const _schema = await getAssetRequestManagementDetail(id)

      setSchema(_schema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isAssetCirculating>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isAssetCirculating>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isAssetCirculating>
        <ContentHeader
          header={schema.header}
          subHeader={schema?.subHeader || ''}
          isNotCallApi
          isShowGoButton
        />

        <AssetRequestManagementDetailWidgets schema={schema} />

        <br />
      </SidebarProposal>
    </div>
  )
}
